export const TaskReport = {
  perc: 'perc',
  óra: 'óra',
};

export const TaskReportOptions = [
  { value: TaskReport.perc, label: 'Perc' },
  { value: TaskReport.óra, label: 'Óra' },
];
